module.exports = __webpack_public_path__ + "static/img/pagj_card_item_bg.6c821f25.png";